module.exports = __webpack_public_path__ + "img/laptop.6fa4fc76.png";